import * as React from "react";
import InputMask from "react-input-mask";
import { FastField } from "formik";
import { posNumberonChange } from "./utils";
import { Checkbox, ColorPicker, FieldOpeningHoursV2, FormGroup } from "@lib/components";
import { Input } from "@lib/components";
import { Button } from "@lib/components";
import { RotateLoader } from "@lib/components";
import { Switch } from "@lib/components";
import { TabSelect } from "@lib/components";
import { SelectAdv, SelectServices } from "@lib/components";
import { FieldOpeningHours } from "@lib/components";
import { inject, observer } from "mobx-react";
import { Modal } from "@lib/components";
import { ModalContent } from "@lib/components";
import { CoreUtils, getId, ListOrderTimesOptions, ListServicesOptionsNoB, RestaurantUtils } from '@lib/common';
import { Tag } from "@lib/components";
import { MobxComponent } from "../../../../../mobx/components";
import { RestaurantForm } from "../../../../../mobx/components/restaurant-form";
import { MenuItemText } from "../menus/layout/floating-button";
import { IconDelete, IconGreenEllipse, IconHelp, IconRedEllipse } from "../../../../components/v2/icons";
import { SettingsFormGroup, SettingsFormGroupInput, SettingsFormLabelContainer, SettingsFormLabelLeftContainer, SettingsFormLabelRightContainer, SettingsFormInputContainer, SettingsSwitchContainer, SettingsActionButtonContainer, SettingsActionButtonWrapper, OptionalText } from "../settings-v2";
import { TabGroup, TabItem } from "../settings-v2/receipt-printing";
import { MenuActionContainer, MenuActionItem, MenuColorBodyWrapper, MenuColorColorPickerText, MenuColorColorPickerWrapper, MenuColorDescription, MenuColorFormGroup, MenuColorLabel, MenuColorPresetsList, MenuColorPresetsListItem, MenuColorPresetsListItemContent, MenuPublishPlatFormItem, MenuPublishPlatFormItemHeader, MenuPublishPlatFormItemHeaderLabel, MenuPublishPlatformContainer, MenuServiceTypeContainer, MenuServiceTypeItem, MenuToggleContainer, MenuToggleText } from "../../../../components/v2/layout.c";
import { PRESET_COLORS } from "../../../../components/v2/menucolor";
import type { AffectedEntityRow, OverrideChangesSummary } from "../../../../components/v2/menupreoverride";
import { UI } from "../../../../../core/ui";
import { runOnceNotification } from "../../../../utils/run_once_notification";
import { toJS } from "mobx";
import { cloneDeep, isEmpty, isObject } from "lodash";
import { POS_PRINTERS } from "../../../../components/v2/data";
import { MenuPresence } from "../../../../components/menu-presence";

function menuDefinesPosOnlineBlocks(conditions: any): {
	defines: boolean;
	pos: any;
	online: any;
} {
	const sourcePos = conditions?.pos;
	const sourceOnline = conditions?.online;
	const defines =
		(sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0) ||
		(sourceOnline != null && typeof sourceOnline === "object" && Object.keys(sourceOnline).length > 0);
	return { defines, pos: sourcePos, online: sourceOnline };
}

/** Only fills `pos` / `online` when that field is still `undefined` or `null` on the child row. */
function mergeAvailabilityWithPosOnline(resolved: any, sourcePos: any, sourceOnline: any): any | null {
	const base = resolved && typeof resolved === "object" ? cloneDeep(resolved) : {};
	let changed = false;

	const parentHasPos =
		sourcePos != null && typeof sourcePos === "object" && Object.keys(sourcePos).length > 0;
	const parentHasOnline =
		sourceOnline != null &&
		typeof sourceOnline === "object" &&
		Object.keys(sourceOnline).length > 0;

	if (parentHasPos && (resolved == null || resolved.pos === undefined || resolved.pos === null)) {
		base.pos = cloneDeep(sourcePos);
		changed = true;
	}
	if (
		parentHasOnline &&
		(resolved == null || resolved.online === undefined || resolved.online === null)
	) {
		base.online = cloneDeep(sourceOnline);
		changed = true;
	}

	return changed ? base : null;
}

interface Option {
	label: string;
	value: string;
}
type FormValues = T.Schema.Restaurant.Menu.RestaurantMenu | T.Schema.Restaurant.Menu.RestaurantMenuV2;
interface Props {
	type: "edit" | "create";
	abacus_type?: "edit" | "create";
	initialValues: FormValues | null;
	close: () => void;
	/** When set, POS/online save may open descendant override modal before API (list wires this). */
	v2VisibilityDelegate?: (args: {
		entity: 'menu' | 'category';
		menuIndex: number;
		menuId: string;
		categoryId?: string;
		categoryIndex?: number;
		nextConditions: any;
		entityName: string;
	}) => Promise<boolean>;
	onReceiptPrinterMenuConflict?: (payload: {
		menuIndex: number;
		menuId: string;
		menuName: string;
		itemIds: string[];
		selectedPrinterIds: string[];
		affectedEntities: AffectedEntityRow[];
		changesSummary: OverrideChangesSummary;
	}) => void;
	v2PrintersDelegate?: (args: {
		entity: 'menu' | 'category';
		menuIndex: number;
		menuId: string;
		categoryId?: string;
		categoryIndex?: number;
		nextPosPrinters: readonly any[];
		entityName: string;
	}) => Promise<boolean>;
}
interface State {
	tab: string;
	companiesFetched: boolean;
	options: Option[];
	fetching: boolean;
	generating: boolean;
	generatingAbacus: boolean;
	generated: boolean;
	generatedAbacus: boolean;
	// menu_id: string;
	company_id: string;
	isChecking: boolean;
	isCheckingAbacus: boolean;
	backgroundStatus: string;
	backgroundStatusAbacus: string;
	disableGenerate: boolean;
	disableAbacusGenerate: boolean;
	color: string;
	/** Printer _ids selected for this menu (eligible items); state-only until v2 endpoint exists */
	selectedPrinterIdsForEligible: string[];
	printerStatusById: Record<string, T.API.DashboardPrinterStatusResItem>;
}


/** The id of whatever this editor has open, in either menu schema. */
function presenceEntityId(initialValues: any): string | undefined {
	return initialValues?.id || initialValues?._id || undefined;
}

function MenuPresenceBar(props: { entityId?: string }) {
	return (
		<div style={{ display: 'flex', justifyContent: 'flex-end', padding: '0 4px 8px' }}>
			<MenuPresence scope="current-menu" entityId={props.entityId} />
		</div>
	);
}

@inject("store")
@observer
export class RestaurantFormMenuV2 extends MobxComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			tab: "0",
			companiesFetched: false,
			options: [],
			fetching: false,
			generating: false,
			generatingAbacus: false,
			generated: false,
			generatedAbacus: false,
			// menu_id: "",
			company_id: "",
			isChecking: false,
			isCheckingAbacus: false,
			backgroundStatus: "Unknown",
			backgroundStatusAbacus: "Unknown",
			disableGenerate: false,
			disableAbacusGenerate: false,
			color: '#000',
			selectedPrinterIdsForEligible: [],
			printerStatusById: {},
		};
	}

	setTab = (tab: string) => {
		this.setState({ tab });
	};

	componentDidMount = () => {
		this.setState({
			tab: "0",
			companiesFetched: false,
			options: [],
			fetching: false,
			generating: false,
			generated: false,
			// menu_id: ""
		});
    const r = this.injected.store.restaurant!;
    if (r?.settings?.printers) {
      // @ts-ignore
      const assignedPrinterIds = RestaurantUtils.menu.getAssignPrintersByTypeV2(r, 'menu', this.props.initialValues?.id || '');
      this.setState({ selectedPrinterIdsForEligible: assignedPrinterIds });
			this.loadPrinterStatus();
    }

		// Inside the editor is what "editing" means to everyone else. A new menu has no id, so it reads as the list.
		const initial = this.props.initialValues as { id?: string; _id?: string; name?: string } | undefined;
		const editingId = initial?.id || initial?._id;
		if (editingId) {
			this.injected.store.notifications.menuPresenceSetEntity('menu', editingId, initial?.name || null);
		}
	};

	componentWillUnmount() {
		// Back to the menu, not out of it, or an "editing" marker is stranded on everyone else's screen.
		this.injected.store.notifications.menuPresenceClearEntity();
	}

	componentDidUpdate(prevProps: Props) {
		const prevPresenceId = presenceEntityId(prevProps.initialValues);
		const nextPresenceId = presenceEntityId(this.props.initialValues);
		if (prevPresenceId !== nextPresenceId) {
			if (nextPresenceId) {
				this.injected.store.notifications.menuPresenceSetEntity(
					'menu', nextPresenceId, (this.props.initialValues as any)?.name || null);
			} else {
				this.injected.store.notifications.menuPresenceClearEntity();
			}
		}

		if (this.props.initialValues && !prevProps.initialValues) {
			this.setTab("0");
			this.loadPrinterStatus();
		}
	}

	loadPrinterStatus = async () => {
		try {
			const { store } = this.injected;
			const r = store.restaurant;
			if (!r?.settings?.printers?.length) return;
			const res = await store.api.printer_status({
				restaurant_id: r._id,
				printers: r.settings.printers.map((p: any) => p._id),
			});
			if (res.outcome) return;
			const printerStatusById: Record<string, T.API.DashboardPrinterStatusResItem> = {};
			for (const item of res.status || []) {
				printerStatusById[item.printerId] = item;
			}
			this.setState({ printerStatusById });
		} catch {
			// ignore status fetch errors
		}
	};

	checkStatus = async () => {
		this.setState(
			{
				isChecking: true,
			},
			async () => {
				const _id =
					this.injected.store.restaurant &&
						this.injected.store.restaurant._id
						? this.injected.store.restaurant._id
						: "";
				const result = await this.injected.store.checkStatus(_id);
				if (this.state.backgroundStatus !== result) {
					// If the status changed, refresh the data
					const res = await this.injected.store.api.restaurant({
						_id: _id,
					});
					///@ts-ignore
					const { restaurant } = res;
					this.injected.store.setRestaurant(restaurant);
				}
				this.setState({
					isChecking: false,
					backgroundStatus: result,
				});
			}
		);
	};

	checkAbacusStatus = async () => {
		console.log("Abacus Called");
		this.setState(
			{
				isCheckingAbacus: true,
			},
			async () => {
				const _id =
					this.injected.store.restaurant &&
						this.injected.store.restaurant._id
						? this.injected.store.restaurant._id
						: "";
				const result = await this.injected.store.checkStatusAbacus(_id);
				console.log({ result });
				if (this.state.backgroundStatusAbacus !== result) {
					// If the status changed, refresh the data
					const res = await this.injected.store.api.restaurant({
						_id: _id,
					});
					///@ts-ignore
					const { restaurant } = res;
					this.injected.store.setRestaurant(restaurant);
				}
				this.setState({
					isCheckingAbacus: false,
					backgroundStatusAbacus: result,
				});
			}
		);
	};

	generateMenu = async (menu_id: string) => {
		//
		this.setState({
			generating: true,
			generated: false,
			disableGenerate: true,
		});
		const _id =
			this.injected.store.restaurant && this.injected.store.restaurant._id
				? this.injected.store.restaurant._id
				: "";
		// const site_id = this.in
		const result = await this.injected.store.generateMenu(_id, menu_id);
		this.setState(
			{
				generating: false,
				generated: true,
			},
			async () => {
				// Refresh the data immediately
				const res = await this.injected.store.api.restaurant({
					_id: _id,
				});
				///@ts-ignore
				const { restaurant } = res;
				this.injected.store.setRestaurant(restaurant);
				setTimeout(() => {
					this.setState({
						disableGenerate: false,
					});
				}, 1000);
			}
		);
		//
	};

	generateMenuv2 = async (menu_id: string) => {
		//
		this.setState({
			generating: true,
			generated: false,
			disableGenerate: true,
		});
		const _id =
			this.injected.store.restaurant && this.injected.store.restaurant._id
				? this.injected.store.restaurant._id
				: "";
		// const site_id = this.in
		const result = await this.injected.store.generateMenuv2(_id, menu_id);
		this.setState(
			{
				generating: false,
				generated: true,
			},
			async () => {
				// Refresh the data immediately
				const res = await this.injected.store.api.restaurant({
					_id: _id,
				});
				///@ts-ignore
				const { restaurant } = res;
				this.injected.store.setRestaurant(restaurant);
				setTimeout(() => {
					this.setState({
						disableGenerate: false,
					});
				}, 1000);
			}
		);
		//
	};

	generateAbacusMenu = async (menu_id: string) => {
		//
		this.setState({
			generatingAbacus: true,
			generatedAbacus: false,
			disableAbacusGenerate: true,
		});
		const _id =
			this.injected.store.restaurant && this.injected.store.restaurant._id
				? this.injected.store.restaurant._id
				: "";
		// const site_id = this.in
		const result = await this.injected.store.generateAbacusMenu(
			_id,
			menu_id
		);
		this.setState(
			{
				generating: false,
				generated: true,
			},
			async () => {
				const res = await this.injected.store.api.restaurant({
					_id: _id,
				});
				///@ts-ignore
				const { restaurant } = res;
				this.injected.store.setRestaurant(restaurant);
				setTimeout(() => {
					this.setState({
						disableAbacusGenerate: false,
					});
				}, 1000);
			}
		);
		//
	};

	assignPrinterToMenu = (printer: any) => {
		this.setState((s) => ({
			selectedPrinterIdsForEligible: s.selectedPrinterIdsForEligible.includes(printer._id)
				? s.selectedPrinterIdsForEligible.filter((id) => id !== printer._id)
				: [...s.selectedPrinterIdsForEligible, printer._id]
		}))
	}

	render() {
		const { type, initialValues, close } = this.props;
		const { tab } = this.state;
		const r = this.injected.store.restaurant;
		const { store } = this.injected;
		const { activeMobileMenu } = store
		const activePrinters = store.ably.printers;
		//

		let openItems = false;
		if (
			initialValues &&
			r &&
			r.abacus &&
			typeof r.abacus.abacus_open_items === "boolean" &&
			r.abacus.abacus_open_items === true
		) {
			openItems = true;
		}
		//
		let menu_options: any = [{}];
		///@ts-ignore
		if (
			r &&
			(r._id === "kFkeSP16a" ||
			///@ts-ignore
			r._id === "58b19c3a1667c9685d0f8c63" ||
			///@ts-ignore
			// || r._id === "RESVqm6Ka2KYjhtWTcJn-iMm"
			///@ts-ignore
			r._id === "RES1T_qjKy9PUdDPiVTsVPcd" ||
			///@ts-ignore
			r.reseller_id === "cloudwaitress-test" ||
			///@ts-ignore
			r.reseller_id === "yoom")
		) {
			if (r?.kounta?.enabled) {
				///@ts-ignore
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
					{ label: "Kounta", value: "2" },
				];
			} if (r?.wpos?.wpos_status) {
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
					{ label: "POS", value: "4" },
				];
			} else {
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
				];
			}
		} else {
			if (
				r &&
				r._id &&
				r._id !== "RESVqm6Ka2KYjhtWTcJn-iMm" &&
				r.abacus &&
				r.abacus.abacus_status === true &&
				openItems === false
			) {
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
					// { label: "Kounta", value: "2" },
					{ label: "Abacus", value: "3" },
				];
			} else if (
				///@ts-ignore
				(r._id === "RESoMB_ZxZYNZaa_anfvZol1" ||
					///@ts-ignore
					r._id === "RESVqm6Ka2KYjhtWTcJn-iMm") &&
				openItems === false
			) {
				console.log("Open Items false");
				if (r?.kounta?.enabled) {
					///@ts-ignore
					menu_options = [
						{ label: "General", value: "0" },
						{ label: "Conditions", value: "1" },
						{ label: "Kounta", value: "2" },
						{ label: "Abacus", value: "3" },
					];
				} else {
					menu_options = [
						{ label: "General", value: "0" },
						{ label: "Conditions", value: "1" },
						{ label: "Abacus", value: "3" },
					];
				}
			} if (r?.wpos?.wpos_status) {
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
					{ label: "POS", value: "4" },
				];
			} else {
				menu_options = [
					{ label: "General", value: "0" },
					{ label: "Conditions", value: "1" },
				];
			}
		}
		let initialKountaValues =
			//@ts-ignore
			initialValues && initialValues.kounta_sync
				//@ts-ignore
				? initialValues.kounta_sync
				: {};
		if (Object.keys(initialKountaValues).length === 0) {
			initialKountaValues = {
				kounta_sync_export_enabled: false,
			};
		}

		return (

				<>
					{(activeMobileMenu.name ! == 'create-menu' || activeMobileMenu.name ! == 'edit-menu') && <TabGroup className='menus'>
						<TabItem
							active={this.state.tab === '0'}
							onClick={() => this.setState({ tab: '0'})}
						>
						General
						</TabItem>
						<TabItem
							active={this.state.tab === '1'}
							onClick={() => this.setState({ tab: '1'})}
						>
						Condition
						</TabItem>
						<TabItem
							active={this.state.tab === '2'}
							onClick={() => this.setState({ tab: '2'})}>
							POS
						</TabItem>
					</TabGroup>}

				<RestaurantForm<FormValues>
					submit={async (r, values) => {
						const existing = r.menus.findIndex(
							//@ts-ignore
							(p: any) => p._id === values._id
						);

						//@ts-ignore
						const printers = values.integrations?.pushpos.printers || [];

						if(printers.length > 0 ) { //propagate to categories and dishes / items
							//@ts-ignore
							values.categories = values.categories.map(c => {
								//@ts-ignore
								let cpushpos = c.integrations?.pushpos || {};
								if(isEmpty(cpushpos)) {
									return {
										...c,
										integrations: {
											pushpos: {
												...cpushpos,
												printers: printers
											}
										},
										//@ts-ignore
										dishes: c.dishes.map( d => {
											//@ts-ignore
											let dpushpos = d.integrations?.pushpos || {};
											if(isEmpty(dpushpos)) {
												return {
													...d,
													integrations: {
														pushpos: {
															...dpushpos,
															printers: printers
														}
													},
												};
											} return d;
										})
									};
								} return c;
							})
						}
						if (existing === -1) {
							//@ts-ignore
							r.menus.push(values);
						} else {
							//@ts-ignore
							r.menus[existing] = values;
						}
						const update = { $set: { menus: r.menus } };
						return { r, update };
					}}

					customSubmit={
						(store.isNewMenuSchema) ?
							async (values, form) => {
								const r = store.restaurant!;
								let targetMenus = r.menus;
								if(store.isNewMenuSchema) {
									//@ts-ignore
									targetMenus = (r.menus_v2 || []);
								}
								const existing = targetMenus.findIndex(
									//@ts-ignore
									(p: any) =>  getId(p) === getId(values)
								);

								if(existing === -1) {
									try {

										let copyValues = cloneDeep(values);
										if(store.isNewMenuSchema) {
											// v2 API: conditions → availability, strip client-only fields
											//@ts-ignore
											copyValues.availability = values.conditions;
											//@ts-ignore
											delete copyValues.conditions;
											//@ts-ignore
											delete copyValues.id;
											//@ts-ignore
											delete copyValues.availabilities;
											//@ts-ignore
											delete copyValues.availability_id;
											//@ts-ignore
											delete copyValues.items;
											//@ts-ignore
											delete copyValues.categories;
											//@ts-ignore
											delete copyValues._metadata as any;

										}

										const res = await store.api.menu_create_menu({
											restaurant_id: r?._id,
											menu: copyValues
										});

										if(res.error) {
											UI.notification.error(res.message)
										} else {
											UI.notification.success('Menu added')
											if (store.isNewMenuSchema && r._id) {
												try {
													const got = await store.api.menu_get_menus(r._id);
													if (got?.menus) {
														await store.updateRestaurant({ menus_v2: got.menus });
													}
												} catch {
													/* best-effort */
												}
											}
											store.setActiveMobileMenu(
												store.activeMobileMenu.referrer.pop()!,
												Array.from(new Set(store.activeMobileMenu.referrer))
											)

										}
									} catch (e) {
										UI.notification.error(e?.error ?? e?.message ?? 'An error occurred');
									}
									form.setSubmitting(false);
								} else {
									try {
										//@ts-ignore
										const menuAvailabilities = values.availabilities;
										//@ts-ignore
										const menuConditionsBeforeApi = values.conditions;
										//@ts-ignore
										const menuAvailId = menuConditionsBeforeApi?.id;
										const { defines: menuDefinesPosOnline, pos: menuSourcePos, online: menuSourceOnline } =
											menuDefinesPosOnlineBlocks(menuConditionsBeforeApi);

										const resolveMenuAvail = (aid: string | undefined) =>
											aid && menuAvailabilities
												? (menuAvailabilities as any[]).find((a: any) => a.id === aid) ?? null
												: null;
										const menuItemIds = (values as any).items?.map((i: any) => getId(i)) || [];
										const receiptPrinters = r.settings?.printers ?? [];
										const selectedPrinterIds = [...this.state.selectedPrinterIdsForEligible].sort();
										const selectedKey = selectedPrinterIds.join('\0');
										let receiptConflictCount = 0;
										for (const itemId of menuItemIds) {
											const currentKey = RestaurantUtils.menu
												.receiptPrinterIdsAssigningItem(receiptPrinters, itemId)
												.slice()
												.sort()
												.join('\0');
											if (currentKey !== selectedKey) receiptConflictCount++;
										}
										const shouldDeferReceiptOverride =
											store.isNewMenuSchema &&
											menuItemIds.length > 0 &&
											receiptConflictCount > 0 &&
											!!this.props.onReceiptPrinterMenuConflict;
										if (shouldDeferReceiptOverride && this.props.onReceiptPrinterMenuConflict) {
											const nameById = (id: string) =>
												(receiptPrinters as { _id?: string; name?: string }[]).find((p) => p._id === id)?.name ?? id;
											const selectedNames = selectedPrinterIds.map(nameById);
											const affectedEntities: AffectedEntityRow[] = [];
											for (const itemId of menuItemIds) {
												const curIds = RestaurantUtils.menu
													.receiptPrinterIdsAssigningItem(receiptPrinters, itemId)
													.slice()
													.sort();
												if (curIds.join('\0') === selectedKey) continue;
												const it = ((values as any).items || []).find((x: any) => getId(x) === itemId);
												affectedEntities.push({
													entityType: 'item',
													id: itemId,
													name: (it as { name?: string } | undefined)?.name ?? String(itemId).slice(0, 8),
													printers: {
														from: curIds.map(nameById),
														to: selectedNames,
													},
												});
											}
											const changesSummary: OverrideChangesSummary = {
												printers: {
													from: [
														`${affectedEntities.length} item(s) use different receipt printers than this menu selection`,
													],
													to: selectedNames.length ? selectedNames : ['—'],
												},
											};
											this.props.onReceiptPrinterMenuConflict({
												menuIndex: existing,
												menuId: getId(values),
												menuName: (values as any).name ?? '',
												itemIds: menuItemIds,
												selectedPrinterIds: [...selectedPrinterIds],
												affectedEntities,
												changesSummary,
											});
											form.setSubmitting(false);
											return;
										}
										const nextPosPrinters = ((values as any)?.integrations?.pushpos?.printers ??
											[]) as any[];
										const currentMenuRow = (r?.menus_v2 || [])[existing];
										const currentPosPrinters = ((currentMenuRow as any)?.integrations?.pushpos?.printers ??
											[]) as any[];
										const nextMenuColor = (values as any)?.color;
										const currentMenuColor = (currentMenuRow as any)?.color;
										const menuColorChanged =
											JSON.stringify(nextMenuColor ?? null) !==
											JSON.stringify(currentMenuColor ?? null);
										const nextPosColor = (values as any)?.integrations?.pushpos?.color;
										const currentPosColor = (currentMenuRow as any)?.integrations?.pushpos?.color;
										const posColorChanged =
											JSON.stringify(nextPosColor ?? null) !==
											JSON.stringify(currentPosColor ?? null);
										const currentMenuAvail = (currentMenuRow as any)?.availabilities?.find(
											(a: any) => a.id === (currentMenuRow as any)?.availability_id
										);
										const visibilityChanged =
											JSON.stringify((currentMenuAvail as any)?.pos ?? null) !==
												JSON.stringify((menuConditionsBeforeApi as any)?.pos ?? null) ||
											JSON.stringify((currentMenuAvail as any)?.online ?? null) !==
												JSON.stringify((menuConditionsBeforeApi as any)?.online ?? null) ||
											JSON.stringify((currentMenuAvail as any)?.external_platforms ?? null) !==
												JSON.stringify((menuConditionsBeforeApi as any)?.external_platforms ?? null);
										const printersChanged =
											JSON.stringify([...currentPosPrinters].sort()) !==
											JSON.stringify([...nextPosPrinters].sort());
										const selectedEligiblePrinterIds = this.state.selectedPrinterIdsForEligible || [];

										if (
											store.isNewMenuSchema &&
											this.props.v2VisibilityDelegate &&
											menuDefinesPosOnline &&
											visibilityChanged
										) {
											const deferred = await this.props.v2VisibilityDelegate({
												entity: 'menu',
												menuIndex: existing,
												menuId: getId(values),
												nextConditions: menuConditionsBeforeApi,
												entityName: (values as any).name || 'Menu',
											});
											if (deferred) {
												form.setSubmitting(false);
												return;
											}
										}
										if (
											store.isNewMenuSchema &&
											this.props.v2PrintersDelegate &&
											printersChanged
										) {
											const deferredPrinters = await this.props.v2PrintersDelegate({
												entity: 'menu',
												menuIndex: existing,
												menuId: getId(values),
												nextPosPrinters,
												entityName: (values as any).name || 'Menu',
											});
											if (deferredPrinters) {
												form.setSubmitting(false);
												return;
											}
										}

										let copyValues = cloneDeep(values);
										if(store.isNewMenuSchema) {
											// v2 API: conditions → availability, availability_id; strip client-only fields
											//@ts-ignore
											copyValues.availability = values.conditions;
											//@ts-ignore
											copyValues.availability_id = values.conditions?.id;
											//@ts-ignore
											delete copyValues.conditions;
											//@ts-ignore
											delete copyValues.availabilities;

											//@ts-ignore
											delete copyValues._metadata as any;

											// check if media url is empty or undefined, delete it
											//@ts-ignore
											if(!copyValues.media_url || copyValues.media_url === '') {
												//@ts-ignore
												delete copyValues.media_url;
											}
										}

										const res = await store.api.menu_partial_update_menu({
										restaurant_id: r?._id,
										//@ts-ignore
										menu_id: getId(copyValues),
										data: copyValues
									})
									//@ts-ignore
									const printers = copyValues?.integrations?.pushpos.printers || [];
									//@ts-ignore
									const posColor = copyValues?.integrations?.pushpos.color || '';
									const legacyDescendantSync =
										printersChanged || posColorChanged || menuColorChanged;
									const runDescendantSync =
										legacyDescendantSync || (menuDefinesPosOnline && visibilityChanged);

									//@ts-ignore
									if (runDescendantSync) {
										await Promise.all((copyValues.categories || []).map(async (c: any) => {
											let cpushpos = c.integrations?.pushpos || {};
											//@ts-ignore
											let toUpdateData: any = {};

											if(menuColorChanged && isEmpty(c.color)) {
												//@ts-ignore
												toUpdateData.color = copyValues.color
											}

											if(isEmpty(cpushpos) && (printersChanged || posColorChanged)) {
												const nextPushpos: any = { ...cpushpos };
												if (printersChanged) nextPushpos.printers = printers;
												if (posColorChanged) nextPushpos.color = posColor;
												//@ts-ignore
												toUpdateData.integrations = {
													pushpos: {
														...nextPushpos,
													}
												}
											}

											//@ts-ignore
											const catAid = c.availability_id || menuAvailId;
													if (
														menuDefinesPosOnline &&
														visibilityChanged &&
														menuAvailId &&
														catAid !== menuAvailId
													) {
												const resolvedCat = resolveMenuAvail(catAid);
												const mergedCatAvail = mergeAvailabilityWithPosOnline(
													resolvedCat,
													menuSourcePos,
													menuSourceOnline
												);
												if (mergedCatAvail != null) {
													toUpdateData.availability = mergedCatAvail;
													toUpdateData.availability_id = catAid;
												}
											}

											if(!isEmpty(toUpdateData)) {
												await store.api.menu_partial_update_category({
													restaurant_id: r._id,
													menu_id: getId(copyValues),
													category_id: getId(c),
													data: toUpdateData
												});
											}

											const menuId = getId(copyValues);
											const categoryId = getId(c);
											//@ts-ignore
											const itemUpdates = copyValues.items
												.filter((item: any) => item.category_id === categoryId)
												.map((d: any) => {
													let dpushpos = d.integrations?.pushpos || {};
													let itemPatch: any = {};
													if(menuColorChanged && isEmpty(d.color)) {
														//@ts-ignore
														itemPatch.color = copyValues.color
													}

													if(isEmpty(dpushpos) && (printersChanged || posColorChanged)) {
														const nextPushpos: any = { ...cpushpos };
														if (printersChanged) nextPushpos.printers = printers;
														if (posColorChanged) nextPushpos.color = posColor;
														//@ts-ignore
														itemPatch.integrations = {
															pushpos: {
																...nextPushpos,
															}
														}
													}

													if (menuDefinesPosOnline && visibilityChanged && menuAvailId) {
														//@ts-ignore
														const itemAid = d.availability_id || catAid;
														if (itemAid !== menuAvailId && itemAid !== catAid) {
															const resolvedItem = resolveMenuAvail(itemAid);
															const mergedItemAvail = mergeAvailabilityWithPosOnline(
																resolvedItem,
																menuSourcePos,
																menuSourceOnline
															);
															if (mergedItemAvail != null) {
																itemPatch.availability = mergedItemAvail;
																itemPatch.availability_id = itemAid;
															}
														}
													}
													if (isEmpty(itemPatch)) return;
													const data: any = {};
													if (itemPatch.color != null) data.color = itemPatch.color;
													if (itemPatch.integrations != null) data.integrations = itemPatch.integrations;
													if (itemPatch.availability != null) {
														data.availability = itemPatch.availability;
														data.availability_id = itemPatch.availability_id;
													}
                          return {
                            menu_id: menuId,
                            category_id: categoryId,
                            id: getId(d),
                            ...data,
                          }
												}).filter(Boolean);
											if (itemUpdates.length) {
                        await store.api.menu_partial_update_batch_items({
                          restaurant_id: r._id,
                          data: {items: itemUpdates}
                        })
                      }
										}));
									}

										if(res.error) {
											UI.notification.error(res.message);
										} else {
											UI.notification.success('Menu updated');
											if (store.isNewMenuSchema && r._id) {
												try {
													const got = await store.api.menu_get_menus(r._id);
													if (got?.menus) {
														await store.updateRestaurant({ menus_v2: got.menus });
													}
												} catch {
													/* best-effort: list / override flow still uses local form state */
												}
											}
											store.setActiveMobileMenu(
												store.activeMobileMenu.referrer.pop()!,
												Array.from(new Set(store.activeMobileMenu.referrer))
											);
										}
									} catch(e) {
										UI.notification.error(e?.error ?? e?.message ?? 'An error occurred');
									}
									form.setSubmitting(false);
								}
                // @ts-ignore
                const itemIds = values.items?.map((i: any) => getId(i)) || [];
                const shouldUpdateReceiptEligibility =
                  JSON.stringify([...this.state.selectedPrinterIdsForEligible].sort()) !==
                  JSON.stringify(
                    (
                      RestaurantUtils.menu.getAssignPrintersByTypeV2(
                        r,
                        'menu',
                        getId(values)
                      ) || []
                    ).slice().sort()
                  );
                if (itemIds.length && shouldUpdateReceiptEligibility) {
                  const { updatedPrinters, updateQuery } = RestaurantUtils.menu.assignItemsToPrinterV2(r, itemIds, this.state.selectedPrinterIdsForEligible);
                  await store.api.restaurant_update({
                    _id: r._id,
                    update: updateQuery
                  })
                  r.settings.printers = updatedPrinters;
                  store.setRestaurant({ ...r });
                }
							}
						: undefined
					}
					validators={{
						name: (values) => {
						  if (!values.name)
							return { name: "This field is required" };
						},
						"conditions.pre_order.cutoff_time": (values) => {
							//@ts-ignore
							if (!values.conditions.pre_order.cutoff_time) {
								return;
							}
							if (
								!/^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(
									//@ts-ignore
									values.conditions.pre_order.cutoff_time
								)
							) {
								return {
									"conditions.pre_order.cutoff_time":
										"Invalid time format. Please use 24-hour format (max value is 23.59)",
								};
							}
						}
					}}
					initialValues={initialValues}
					onSuccess={async () => {
						store.setActiveMobileMenu(
							store.activeMobileMenu.referrer.pop()!,
							Array.from(new Set(store.activeMobileMenu.referrer))
						)
						close()
					}}
					onSuccessMessage={
						type === "edit" ? "Menu edited" : "Menu created"
					}
					onError={() => UI.notification.error("An error occurred")}

				>
					{({ form, error, getFieldError, }) => {
						const { isSubmitting, setFieldValue } = form;
						const nameValue = form.values.name;
            			const displayNameValue = form.values.display_name;
						const descValue = form.values.description;
						//@ts-ignore
						const currentAssignPOSPrinters = form.values?.integrations?.pushpos?.printers || [] as number[];
						console.log('currentAssignPOSPrinters', currentAssignPOSPrinters);

						runOnceNotification(error)
						return (
							<div>
								<MenuPresenceBar entityId={presenceEntityId(this.props.initialValues)} />
								<div>
									{this.state.tab === '0' && <>
									<SettingsFormGroup>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'name')) || null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="name"
													render={({ field }: any) => (
													<input
														type="text"
														required
														{...field}
														value={nameValue}
														/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Display Name</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
													name="display_name"
													render={({ field }: any) => (
													<input
														type="text"
														{...field}
                            value={displayNameValue}
														/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Description</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer>
												<IconHelp />
												</SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
												<FastField
													name="description"
													render={({ field }: any) => (
													<input
														type="text"
														{...field}
														value={descValue}
														/>
													)} />
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput>
											<MenuColorFormGroup>
												<MenuColorLabel>Enable Table Ordering</MenuColorLabel>
												<MenuToggleContainer>
													<FastField
														name="conditions.table_order.enabled"
														render={({ field }: any) => (
													<Switch
														id="table-ordering-enabled"
														checked={field.value || false}
														onChange={(e) => setFieldValue('conditions.table_order.enabled', e.target.checked)}
													/>) } />
												</MenuToggleContainer>
											</MenuColorFormGroup>
											<p className="desc">Enabling this will allow customers to order from this menu via table order</p>

										</SettingsFormGroupInput>
										{store.isNewMenuSchema && <>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>This group will be active on<OptionalText>(Required)</OptionalText></SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorFormGroup>
													<MenuColorLabel>POS</MenuColorLabel>
													<MenuToggleContainer>
														<FastField
															name="conditions.pos.enabled"
															render={({ field }: any) => (
														<Switch
															id="pos-enabled"
															checked={field.value}
															onChange={(e) => setFieldValue('conditions.pos.enabled', e.target.checked)}
														/>) } />
													</MenuToggleContainer>
												</MenuColorFormGroup>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorLabel>Select Service Type</MenuColorLabel>
												<SettingsFormInputContainer>
													<FastField
													name="conditions.pos.services"
													render={({ field }: any) => (
														<SelectServices
														type="multi"
														value={field.value || []}
														onChange={(
															options: string[]
														) => {
															setFieldValue(
																"conditions.pos.services",
																options
															);
														}}

														options={ListServicesOptionsNoB}/>
													)} />
												</SettingsFormInputContainer>

											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorFormGroup>
													<MenuColorLabel>Online</MenuColorLabel>
													<MenuToggleContainer>
														<FastField
															name="conditions.online.enabled"
															render={({ field }: any) => (
														<Switch
															id="online-enabled"
															checked={field.value}
															onChange={(e) => setFieldValue('conditions.online.enabled', e.target.checked)}
														/>) } />
													</MenuToggleContainer>
												</MenuColorFormGroup>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<MenuColorLabel>Select Service Type </MenuColorLabel>
												<SettingsFormInputContainer>
													<FastField
													name="conditions.online.services"
													render={({ field }: any) => (
														<SelectServices
														type="multi"
														value={field.value || []}
														onChange={(
															options: string[]
														) => {
															setFieldValue(
																"conditions.online.services",
																options
															);
														}}

														options={ListServicesOptionsNoB}/>
													)} />
												</SettingsFormInputContainer>
											</SettingsFormGroupInput>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Assign printer for this menu</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												{r!.settings.printers.length > 0 ?
												r?.settings.printers.map(printer => (
												<MenuActionContainer
													key={printer._id}>
													 <MenuActionItem
														onClick={() =>this.assignPrinterToMenu(printer)}
														className="menu-printer-item">
														<div className='printer-checkbox'>
															<Checkbox
																id={printer._id}
																checked={this.state.selectedPrinterIdsForEligible.includes(printer._id)}
																onChange={() => this.assignPrinterToMenu(printer)}
																onClick={(e) => e.stopPropagation()}
															/>
															{printer.name}
														</div>

														{(() => {
															const printerStatus = this.state.printerStatusById[printer._id];
															const connected =
																!printer.disabled &&
																(printerStatus
																	? !!printerStatus.online
																	: activePrinters.indexOf(printer.api_key) !== -1);
															return connected ? (
																<span>
																	<IconGreenEllipse />
																	Connected
																</span>
															) : (
																<span>
																	<IconRedEllipse />
																	Disconnected
																</span>
															);
														})()}

													</MenuActionItem>
												</MenuActionContainer>
												))

												: <p>no printers yet.</p> }
											</SettingsFormGroupInput>
											{/*<SettingsFormGroupInput>*/}
											{/*	<SettingsFormLabelContainer>*/}
											{/*		<SettingsFormLabelLeftContainer>Publish this menu on other platforms</SettingsFormLabelLeftContainer>*/}
											{/*		<SettingsFormLabelRightContainer>*/}
											{/*		<IconHelp />*/}
											{/*		</SettingsFormLabelRightContainer>*/}
											{/*	</SettingsFormLabelContainer>*/}
											{/*	<MenuPublishPlatformContainer>*/}
											{/*		<MenuPublishPlatFormItem>*/}
											{/*			<MenuPublishPlatFormItemHeader>*/}
											{/*				<MenuPublishPlatFormItemHeaderLabel>Uber</MenuPublishPlatFormItemHeaderLabel>*/}
											{/*				<MenuToggleContainer>*/}
											{/*					<MenuToggleText>{*/}
											{/*						//@ts-ignore*/}
											{/*						form.values.external_platforms?.uber?.enabled ? 'On' : 'Off'*/}
											{/*					}</MenuToggleText>*/}
											{/*					<FastField*/}
											{/*						name="conditions.external_platforms.uber.enabled"*/}
											{/*						render={({ field }: any) => (*/}
											{/*					<Switch*/}
											{/*						id="conditions.external_platforms.uber.enabled"*/}
											{/*						checked={field.value}*/}
											{/*						onChange={(e) => setFieldValue('conditions.external_platforms.uber.enabled', e.target.checked)}*/}
											{/*					/>) } />*/}
											{/*				</MenuToggleContainer>*/}
											{/*			</MenuPublishPlatFormItemHeader>*/}
											{/*			/!*<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>*!/*/}
											{/*		</MenuPublishPlatFormItem>*/}
											{/*		<MenuPublishPlatFormItem>*/}
											{/*			<MenuPublishPlatFormItemHeader>*/}
											{/*				<MenuPublishPlatFormItemHeaderLabel>Abacus</MenuPublishPlatFormItemHeaderLabel>*/}
											{/*				<MenuToggleContainer>*/}
											{/*					<MenuToggleText>{*/}
											{/*						//@ts-ignore*/}
											{/*					form.values.external_platforms?.abacus?.enabled ? 'On' : 'Off'*/}
											{/*					}</MenuToggleText>*/}
											{/*					<FastField*/}
											{/*						name="conditions.external_platforms.abacus.enabled"*/}
											{/*						render={({ field }: any) => (*/}
											{/*					<Switch*/}
											{/*						id="conditions.external_platforms.abacus.enabled"*/}
											{/*						checked={field.value}*/}
											{/*						onChange={(e) => setFieldValue('conditions.external_platforms.abacus.enabled', e.target.checked)}*/}
											{/*					/>) } />*/}
											{/*				</MenuToggleContainer>*/}
											{/*			</MenuPublishPlatFormItemHeader>*/}
											{/*			/!*<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et.</p>*!/*/}
											{/*		</MenuPublishPlatFormItem>*/}
											{/*	</MenuPublishPlatformContainer>*/}
											{/*</SettingsFormGroupInput>*/}
										</> }


									</SettingsFormGroup>
									</>}
									{this.state.tab === '1' && <>
									<SettingsFormGroup>
									<SettingsSwitchContainer>
										<SettingsFormLabelLeftContainer>
											Hide Unavailable Menu
										</SettingsFormLabelLeftContainer>
										<FastField
											name="conditions.hide_unavailable_menu"
											render={({ field }: any) => (
												<Switch
													id="conditions.hide_unavailable_menu"
													checked={field.value || false}
													onChange={(e) =>
													setFieldValue(
														"conditions.hide_unavailable_menu",
														e.target
														.checked
													)
													}
												/>
											)}
											/>
										</SettingsSwitchContainer>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'conditions.times'))|| null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Order Times</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
												name="conditions.times"
												render={({ field }: any) => (
														<SelectAdv
															type="multi"
															options={ListOrderTimesOptions}
															value={field.value || []}
															onChange={(options) => setFieldValue("conditions.times", options)}
														/>
												)}
											/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											className="table-overflow-x"
											error={(error && getFieldError(form, 'conditions.hours'))|| null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Applicable Hours</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<FastField
												name="conditions.hours"
												render={({ field }: any) => (
													<FieldOpeningHoursV2
														allowNone={true}
														hours={field.value}
														onChange={(
															opening_hours
														) => setFieldValue(
															"conditions.hours",
															opening_hours
														)} />
												)} />
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'conditions.services'))|| null}>
											<SettingsFormLabelContainer>
												<SettingsFormLabelLeftContainer>Services</SettingsFormLabelLeftContainer>
												<SettingsFormLabelRightContainer><IconHelp /></SettingsFormLabelRightContainer>
											</SettingsFormLabelContainer>
											<SettingsFormInputContainer>
											<FastField
												name="conditions.services"
												render={({ field }: any) => (
														<SelectAdv
															type="multi"
															options={ListServicesOptionsNoB}
															value={field.value || []}
															onChange={(options) => setFieldValue("conditions.services", options)}
														/>
												)}
											/>
											</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsSwitchContainer>
										<SettingsFormLabelLeftContainer>
											Enable Age Restricted Access
										</SettingsFormLabelLeftContainer>
										<FastField
											name="conditions.age_restricted"
											render={({ field }: any) => (
												<Switch
													id="conditions.age_restricted"
													checked={
													field.value
													}
													onChange={(e) =>
													setFieldValue(
														"conditions.age_restricted",
														e.target
														.checked
													)
													}
												/>
											)}
											/>
										</SettingsSwitchContainer>
										<SettingsSwitchContainer>
										<SettingsFormLabelLeftContainer>
											Enable Pre-orders Only
										</SettingsFormLabelLeftContainer>
										<FastField
											name="conditions.pre_order.enabled"
											render={({ field }: any) => (
												<Switch
													id="conditions.pre_order.enabled"
													checked={
													field.value
													}
													onChange={(e) =>
													setFieldValue(
														"conditions.pre_order.enabled",
														e.target
														.checked
													)
													}
												/>
											)}
											/>
										</SettingsSwitchContainer>
										<SettingsFormGroupInput>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Pre-order Days In Advance</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
										<SettingsFormInputContainer>
											<FastField
												name="conditions.pre_order.days_in_advance"
												render={({ field }: any) => (
												<input
													type="number"
													{...field}
													/>
												)} />
										</SettingsFormInputContainer>
										</SettingsFormGroupInput>
										<SettingsFormGroupInput
											error={(error && getFieldError(form, 'conditions.pre_order.cutoff_time')) || null}>
										<SettingsFormLabelContainer>
											<SettingsFormLabelLeftContainer>Pre-order Cutoff Time (24H Format)</SettingsFormLabelLeftContainer>
											<SettingsFormLabelRightContainer>
											<IconHelp />
											</SettingsFormLabelRightContainer>
										</SettingsFormLabelContainer>
											<FastField
												name="conditions.pre_order.cutoff_time"
												render={({ field }: any) => (
													<InputMask
														mask="99:99"
														{...field}
													>
														{(inputProps: any) => (
															<Input
																type="text"
																placeholder="00:00"
																{...inputProps}
															/>
														)}
													</InputMask>
												)} />
										</SettingsFormGroupInput>
									</SettingsFormGroup>

									</>}
									{this.state.tab === '2' && <>
										<SettingsFormGroup>
											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>POS Menu ID</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												<SettingsFormInputContainer>
													<FastField name="integrations.pushpos.menu_id">
														{({ field, form }: any) => (
														<input
															type="number"
															{...field}
															value={field.value ?? ""}
															onChange={posNumberonChange(field, form)}
															/>
														)}
													</FastField>
												</SettingsFormInputContainer>
											</SettingsFormGroupInput>

											<SettingsFormGroupInput>
												<SettingsFormLabelContainer>
													<SettingsFormLabelLeftContainer>Assign printer for this menu</SettingsFormLabelLeftContainer>
													<SettingsFormLabelRightContainer>
													<IconHelp />
													</SettingsFormLabelRightContainer>
												</SettingsFormLabelContainer>
												{POS_PRINTERS.map(printer => (
												<MenuActionContainer
													className="condensed"
													key={printer.value.toString()}>
													 <MenuActionItem
														onClick={() => {}}
														className="menu-printer-item">
														<div className='printer-checkbox'>
															<Checkbox
																id={printer.value.toString()}
																onChange={(e) => {
																	if(e.target.checked) {
																		setFieldValue(
																			'integrations.pushpos.printers',
																			Array.from(new Set([...currentAssignPOSPrinters, printer.value ]))
																		)
																	} else {
																		setFieldValue(
																			'integrations.pushpos.printers',
																			currentAssignPOSPrinters.filter( (p: number) => p !== printer.value)
																		)
																	}
																}}
																checked={currentAssignPOSPrinters.includes(printer.value)}/>
															{printer.label}
														</div>

													</MenuActionItem>
												</MenuActionContainer>
												))}
											</SettingsFormGroupInput>
											{store.isNewMenuSchema && <>
											<SettingsFormGroupInput>
												<MenuColorBodyWrapper style={{padding: 0}}>
													<MenuColorDescription>Select a color to represent this menu.</MenuColorDescription>
													<MenuColorFormGroup>
														<MenuColorLabel>Menu Color</MenuColorLabel>
														<FastField
														name="integrations.pushpos.color"
														render={({ field }: any) => (
															<MenuColorColorPickerWrapper>
																<ColorPicker
																	color={field.value}
																	onChange={(color) => setFieldValue('integrations.pushpos.color', '#' + CoreUtils.colors.rgbToHex(color))}/>
																<MenuColorColorPickerText>{field.value}</MenuColorColorPickerText>
															</MenuColorColorPickerWrapper>
														)} />
													</MenuColorFormGroup>
													<MenuColorLabel>Pre-sets</MenuColorLabel>
													<MenuColorPresetsList>
														{PRESET_COLORS.reduce((rows: string[][], color: string, index: number) => {
														if (index % 2 === 0) {
															rows.push([color]);
														} else {
															rows[rows.length - 1].push(color);
														}
														return rows;
														}, []).map((pair: string[], rowIndex: number) => (
														<MenuColorPresetsListItem key={rowIndex}>
															{pair.map((color: string, i: number) => (
															<MenuColorPresetsListItemContent
																key={i}
																style={{ backgroundColor: color }}
																onClick={() => setFieldValue('integrations.pushpos.color', color)}
															>
																<span>{color}</span>
															</MenuColorPresetsListItemContent>
															))}
														</MenuColorPresetsListItem>
														))}

													</MenuColorPresetsList>
												</MenuColorBodyWrapper>
											</SettingsFormGroupInput> </> }
										</SettingsFormGroup>
									</>}
									<SettingsActionButtonContainer>
										<SettingsActionButtonWrapper style={{ left: 0}}>
											<button type="button"
												className="default btn-cancel"
												onClick={ () => {store.setActiveMobileMenu(
													store.activeMobileMenu.referrer.pop()!,
													Array.from(new Set(store.activeMobileMenu.referrer))
												)}}>
													Cancel
											</button>
											<button type="submit" disabled={isSubmitting}>
												{isSubmitting && <RotateLoader size={2} color="white" />}
												{!isSubmitting && "Save"}
											</button>
										</SettingsActionButtonWrapper>
									</SettingsActionButtonContainer>
									</div>
							</div>
						);
					}}
				</RestaurantForm>
				</>
		);
	}
}
